/*! License details at fancyapps.com/license */
var e = function e(_e, o) {
  var t = [];
  return _e.childNodes.forEach(function (e) {
    e.nodeType !== Node.ELEMENT_NODE || o && !e.matches(o) || t.push(e);
  }), t;
};
export { e as getDirectChildren };